// Profile of Nikolai Genov, German. Source of the profile page and of the PDF in this language.
module.exports = {
  headline: 'AI & Data Science Lead • Healthcare, Life Sciences, Finance',
  summary: 'Promovierter Bioinformatiker und technischer Lead für KI-gestützte Softwareentwicklung und Analytics in regulierten Healthcare-, Life-Sciences- und Finanzumgebungen. Expertise in LLM-/RAG-Systemen, MCP, klinischen Daten, Banking-Prognosen bis fünf Jahre und automatisiertem Excel-Reporting. Verbindet R-/Python-Entwicklung mit Teamkoordination, Qualitätssicherung und Workshops auf Geschäftsführungsniveau; AI-Act-Zertifizierung und GCP-Training.',
  imageAlt: 'Porträt von Nikolai Genov',
  personal: {
    position: 'Mitgründer und Geschäftsführer der pAIoneer Labs GmbH, Geschäftsführer der Leap Dynamics GmbH',
    location: 'Berlin, Deutschland',
    languages: 'Deutsch und Englisch (fließend), Bulgarisch (fließend)',
    programmingLanguages: 'R, Python, SQL/SQLite, SAS, MATLAB',
    certifications: 'AI-Act-Zertifizierung, GCP-Training (2025)',
    publications: 'Wissenschaftliche Arbeiten u. a. in Scientific Reports, PLOS Biology, IJMS, Frontiers in Physiology und PLOS ONE'
  },
  education: [
    {
      period: '2021',
      field: 'Promotion: Bioinformatik / theoretische Biologie',
      institution: '',
      degree: 'Abschluss: Dr. rer. nat.'
    },
    {
      period: '2015',
      field: 'Studium: Bioinformatik',
      institution: 'Freie Universität Berlin',
      degree: 'Abschluss: M.Sc. Bioinformatik'
    },
    {
      period: '2012',
      field: 'Studium: Bioinformatik',
      institution: 'Freie Universität Berlin',
      degree: 'Abschluss: B.Sc. Bioinformatik'
    }
  ],
  skills: [
    {
      title: 'Kernkompetenzen',
      description: 'KI-gestützte Entwicklung, R/Python, LLM/RAG & MCP, Clinical Data & Bioinformatik, Prognosen & Stresstests, Excel-Reporting, Shiny, technische Führung'
    },
    {
      title: 'Programmierung & Analytics',
      description: 'R, Python, SQL/SQLite, SAS, MATLAB; ggplot2, scikit-learn, Keras/TensorFlow'
    },
    {
      title: 'Anwendungen & Reporting',
      description: 'R Shiny, Streamlit, Tableau, Leaflet, R Markdown, knitr, LaTeX; automatisiertes Excel-/Word-/PDF-Reporting'
    },
    {
      title: 'KI & Integration',
      description: 'OpenCode, ChatGPT, Model Context Protocol (MCP); Ollama, vLLM, LM Studio, Open WebUI, RAG, n8n, Flowise; KI-gestützte Entwicklung mit menschlicher Prüfung'
    },
    {
      title: 'Engineering',
      description: 'Azure DevOps, GitLab CI/CD, Docker, Camunda, Linux, Microsoft Azure, Google Cloud Platform'
    },
    {
      title: 'Bioinformatik',
      description: 'RNA-seq, Microarray, alternatives Spleißen/Isoformen, Gene Set Enrichment, Pathway-/Netzwerkanalyse, Genome Assembly, Survival-Analyse; Bioconductor, Cytoscape, GEO, ArrayExpress, Ensembl BioMart, UniProt/Swiss-Prot, GO, Reactome, KEGG, BioGRID, STRING, ChEMBL'
    },
    {
      title: 'Clinical Data',
      description: 'EDC, CRF, Edit Checks, DMP, Data Validation Plans, UAT, SAE Reconciliation; CDISC SDTM/ADaM, RAW-/SDTM-/ADaM-Pipelines, QC'
    }
  ],
  positions: [
    {
      period: '2022 - April 2024',
      title: 'Reporting-Automatisierung, T-Systems / Europäische Zentralbank (EZB)',
      description: [
        'Entwicklung einer R-Bibliothek für statistische Berichte zu Finanzzeitreihen; Migration von FAME-Logik nach R/Python mit Reticulate und automatisierte Word-/PDF-Ausgaben.',
        'Pipelines zur automatisierten Erstellung von Excel-Reports; Camunda-Integration, GitLab CI/CD, Unit Tests, Linting, SonarQube und technische Dokumentation.',
        'Vertretung des Teamleiters sowie Mitwirkung an Sprint-Planung, technischer Koordination, Qualitätssicherung und Abstimmung mit Stakeholdern.'
      ]
    },
    {
      period: 'Juni 2025 - Dezember 2025',
      title: 'Data Science & Risk Analytics Consultant, Banking',
      description: [
        'Entwicklung von Prognosemodellen mit Planungshorizonten bis zu fünf Jahren sowie Implementierung von Stresstests.',
        'Überarbeitung und Refaktorierung bestehender R-Codebasen sowie Optimierung von vier Geschäftsprozessen; KI-gestützte Entwicklung mit menschlicher Prüfung.',
        'R-/Shiny-Analyseworkflows und Pipelines zur automatisierten Erstellung von Excel-Reports; Umsetzung analytischer Anforderungen in Abstimmung mit Fachbereichen.'
      ]
    },
    {
      period: 'Juni 2025 - Juni 2026',
      title: 'Clinical Data Manager, Pharma / Klinische Studien',
      description: [
        'EDC-Setup, CRF-Design, Edit Checks, Benutzerrollen, Datentransfer-Spezifikationen und UAT; Koordination mit CROs, Laboren und Studienteams.',
        'Erstellung und Review von DMP, Validierungs-, SAE-Reconciliation- und UAT-Dokumenten; Entwicklung R-basierter Validierungsworkflows und Shiny-Anwendungen im GCP-relevanten Umfeld.'
      ]
    },
    {
      period: 'Juli 2026',
      title: 'Klinische Datenpipeline, Dr. Falk Pharma',
      description: [
        'RAW-/SDTM-/ADaM-Analysepipeline in R mit OpenCode und KI-gestützter Entwicklung, Validierung, QC, Nachvollziehbarkeit und automatisierten Excel-Report-Pipelines.'
      ]
    },
    {
      period: '2026',
      title: 'KI-gestütztes Audit-Trail-Reporting, Miltenyi Biotec',
      description: [
        'Implementierung von Audit-Trail-Reports und automatisierten Excel-Report-Pipelines mit OpenCode und KI-gestützter Entwicklung; Reportlogik, Debugging, Dokumentation und menschliche Prüfung.'
      ]
    },
    {
      period: 'Seit 2019',
      title: 'Geschäftsführer & Mitgründer / AI & Data Lead, Leap Dynamics GmbH',
      description: [
        'Leitung von Beratung und technischer Umsetzung in Healthcare, Life Sciences, Finance und KI; eigene Entwicklung, Teamkoordination und Stakeholder-Kommunikation.',
        'LLM-/RAG-Infrastruktur und MCP-Tool-Integration; OpenCode-gestützte R-/Python-Entwicklung für Codegenerierung, Refactoring, Tests und Dokumentation mit menschlicher Prüfung.'
      ]
    },
    {
      period: 'Seit 2022',
      title: 'Krebsregister & Biobank, Medical University Pleven',
      description: [
        'Analyse nationaler Krebsregisterdaten und Shiny-Dashboards für klinische und wissenschaftliche Stakeholder; Datenintegration, Dokumentation und Biobank-Workflows für fünf Krebsarten.'
      ]
    },
    {
      period: 'Seit 2025',
      title: 'Lead Developer, AI Map Europe (ai-map.eu)',
      description: [
        'Produktionsreife R-Shiny-Anwendung; Migration von CSV nach SQLite, Admin-Login, Institutionenverwaltung, Besucheranalysen, bezahlte Einträge und Anfrageformulare mit SMTP-Benachrichtigungen.',
        'UI/UX, SEO, strukturierte Daten und Sitemap/robots; Eingabevalidierung, Ausgabe-Escaping, Login-Drosselung und nur verifizierte öffentliche Datensätze. Prüfung von 400+ Institutionen anhand von ELLIS, CAIRNE, AI NATION, NET4AI, INSAIT und AI-on-Demand; Herkunfts-, Verifikations- und Betriebsdokumentation.'
      ]
    },
    {
      period: 'Seit 2024',
      title: 'LLM-basierte Finanznachrichtenanalyse, Leap Dynamics (internes Projekt)',
      description: [
        'Wiederkehrende Sentiment-Analysen mit LLMs, API-Daten, automatisierten PDF-Berichten, Streamlit-Oberfläche, n8n-Orchestrierung und Flowise-gestütztem Workflow-Testing.'
      ]
    },
    {
      period: '2025',
      title: 'Workshops auf Geschäftsführungsniveau, BVMW',
      description: [
        'Durchführung von Workshops für Teilnehmende auf Geschäftsführungsniveau im BVMW-Umfeld.'
      ]
    },
    {
      period: '2015 - 2019',
      title: 'Wissenschaftlicher Mitarbeiter, Humboldt-Universität / Charité Berlin',
      description: []
    },
    {
      period: '2015 - 2017',
      title: 'CTO & Mitgründer, Promethano GmbH',
      description: [
        'Software und Zeitreihenanwendungen für Life Sciences.'
      ]
    }
  ]
};
